//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import InstantSearch from 'vue-instantsearch';

import algoliasearch from 'algoliasearch/lite';
//Vue.use(InstantSearch);

// const searchClient =

var APP_ID = process.env.MIX_ALGOLIA_APP_ID;
var SEARCH_ID = process.env.MIX_ALGOLIA_SEARCH_ID;

export default {
    props: ['isadmin'],
    data: function data() {
        return {
            showSearch: true,
            appID: APP_ID,
            searchID: SEARCH_ID,
            searchClient: algoliasearch(APP_ID, SEARCH_ID)
        };
    },

    methods: {
        redirectToResident: function redirectToResident(id) {
            axios.get('/prototype/resident/' + id).then(function (response) {
                var data = response.data;

                Event.$emit('refresh-resident-dashboard', data);
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/layout/InstantSearch.vue
// module id = cOg+
// module chunks = 0 1